module.exports = __webpack_public_path__ + "3b64d5f8952315be1d6c04834eea5083.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Pachantiew/taiwan.jpg
// module id = 648
// module chunks = 47